import { useTheme } from "styled-components";
import { LoadingBlock } from "./style";

const Loading = ({ color }) => {
  const theme = useTheme();

  return (
    <LoadingBlock color={color || theme.palette.text.primaryDarker}>
      <div />
      <div />
      <div />
      <div />
    </LoadingBlock>
  );
};

export default Loading;
